// extracted by mini-css-extract-plugin
export default {"container":"mO-z","title":"nO-z","link":"oO-z"};